import { getVacancies } from "../../api/vacancies"
import { ANY_EXPERIENCE, EMPLOYMENTS, EXPERIENCES, ITransformedVacancy } from "../../utils"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useGetFilters } from "../filters"
import { useEffect, useMemo, useState } from "react"


const useGetVacancies = (pages: number, visited: string) => {
  const queryClient = useQueryClient()
  const [res, setRes] = useState<ITransformedVacancy[]>([])

  const [lastFilters, setLastFilters] = useState('')
  const { data: filters } = useGetFilters()
  useEffect(() => {
    setLastFilters(JSON.stringify(filters))
  }, [filters])

  const { data, isPending, isSuccess, isError } = useQuery(
    {
      queryKey: ['vacancies', pages, lastFilters, visited],
      queryFn: async () => {
        return await getVacancies(visited === "new" ? 1 : pages, visited, filters)
      }
    }
  )
  const {vacancies, total} = useMemo(() => {
    return data || {vacancies: [], total: {value: 0, relation: 'eq' as 'eq' | 'gte'}}
  }, [data])

  useEffect(() => {
    setRes([])
    queryClient.resetQueries({queryKey: ['vacancies']})
  }, [lastFilters, visited])

  const currencyMap: Record<string, string> = {
    "RUR": "\u20BD",
    "rub": "\u20BD",
    "руб./мес.": "\u20BD",
    "«руб.»": "\u20BD",
    '': '',
  }

  useEffect(() => {
    const uniqueVacancies = vacancies?.filter(vac => !res.find(r => r.id === vac.id))
    
    const transfromedVacancies: ITransformedVacancy[] | undefined = uniqueVacancies?.map(vacancy => ({
      ...vacancy,
      salary: `${vacancy.salaryFrom || "Нет"}${currencyMap[vacancy.currency] || vacancy.currency} - ${vacancy.salaryTo || "Нет"}${currencyMap[vacancy.currency] || vacancy.currency}`,
      experience: EXPERIENCES.find(exp => exp.value === vacancy.experience)?.label || ANY_EXPERIENCE,
      employment: EMPLOYMENTS.find(emp => emp.value === vacancy.employment)?.label || "",
      createdAt: `${new Date(vacancy.createdAt).toLocaleDateString().split('.').slice(0,-1).join('.')} ${new Date(vacancy.createdAt).toLocaleTimeString().split(':').slice(0,-1).join(':')}`
    })) || []

    setRes(r => [...r, ...transfromedVacancies])
  }, [vacancies])

  return { vacancies: res, total, isLoading: isPending, isSuccess, isError }
}

export default useGetVacancies